/**
 * Button types (based on the HTML type options)
 * Treat this file as an enum.
 * @module buttonTypes
 * @category Buttons
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Regular button
 * @type {string}
 */
export const BUTTON = "button";

/**
 * Submit button
 * @type {string}
 */
export const SUBMIT = "submit";

/**
 * Reset button
 * @type {string}
 */
export const RESET = "reset";
